export const css = {
    underlayVisible: 'kNJyoq-G',
    ' _key': 'apic-theme/dojo/popup'
};
export default css;
